import { DeltaText } from '@spotify/plugin-confidence-activity-react';
import {
  ISSUE_ACTIVITY_TYPES,
  createIssueUpdatesChangeExtension,
} from '@spotify/plugin-confidence-issues-react';

import { isIssueActivityType } from './issueActivityUtils';

export const ISSUE_STRING_CHANGE_EXTENSION = createIssueUpdatesChangeExtension({
  id: 'issue-string-change',
  predicate: options =>
    isIssueActivityType(options.activity, ISSUE_ACTIVITY_TYPES.updated) &&
    options.change.fieldType === 'string',
  render: ({ change }) => (
    <DeltaText
      oldText={change.oldValue ?? ''}
      newText={change.newValue ?? ''}
      disableDiff
    />
  ),
});
